export default {
	props: {
	},
	data(){
		return {
			isShowed: false,
		}
	},
	watch: {
		//
	},
	computed:{
		//
	},
	methods: {
		onClick(){ this._onToggle(!this.isShowed); },
		onShow(){ this._onToggle(true); },
		onHide(){ this._onToggle(false); },
		_onToggle(val){
			this.isShowed = val;
			this.$emit(this.isShowed?'show':'hide');
		}
	},
	mounted(){
		window.addEventListener('click', (ev)=>{
			if(this.isShowed && !this.$refs.control.contains(ev.target)){
				this.onHide();
			}
		});
	},
	template: `
<div ref="control" @click="onClick" :class="[isShowed?'show':'hide']">
	<slot>content</slot>
</div>
`,
}
